module.exports = __webpack_public_path__ + "static/media/man-with-pink-shirt.e7dfa685.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/crop/man-with-pink-shirt.png
// module id = 2101
// module chunks = 0